import React from 'react';
import BaseEChart from './BaseEChart';
import { buildDividendHistoryOption } from './performanceDividendOptions';
import type { DividendChartData } from '@app-types/performanceDividend';
import './DividendHistoryChart.less';

interface DividendHistoryChartProps {
  data: DividendChartData;
  height?: number;
  className?: string;
}

const DividendHistoryChart: React.FC<DividendHistoryChartProps> = ({
  data,
  height = 198,
  className,
}) => {
  const option = buildDividendHistoryOption(data);
  return (
    <div
      className={['dividend-history-chart', className ?? ''].filter(Boolean).join(' ')}
      style={{ height }}
    >
      <div
        className="dividend-history-chart__axis-title dividend-history-chart__axis-title--left"
        aria-hidden="true"
      >
        <span>{data.yAxisLeftLabel}</span>
      </div>
      <div className="dividend-history-chart__plot">
        <BaseEChart
          option={option}
          height={height}
          animate
          ariaLabel="配当金・株価推移チャート"
        />
      </div>
      <div
        className="dividend-history-chart__axis-title dividend-history-chart__axis-title--right"
        aria-hidden="true"
      >
        <span>{data.yAxisRightLabel}</span>
      </div>
    </div>
  );
};

export default DividendHistoryChart;
